import { AppProps } from 'next/dist/next-server/lib/router/router'

const FullHeight = ({ children }: AppProps) => <>{children}</>

export default FullHeight
